import styled from '@emotion/styled';
import { useState, Fragment } from 'react';
import { Button } from 'react-bootstrap';
import AvatarUserPanel from '../../../Common/AvatarUserPanel';
import { getConferenceIdFromURL } from '@/_helpers';
import { conferenceApi } from '@/_services/api/conference';
export const StyledPeople = styled.div`
    width: 100%;
    .accordion {
        margin-bottom: 2rem;
    }
    .accordion .accordionTitle {
        color: white;
        background: transparent;
        border: none;
        outline: none;
    }
`;
export const StyledPeopleItem = styled.div`
    flex: 1;
    display: flex;
    flex-direction: ${(props) => (props.hasInvite ? 'row' : 'column')};
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid #333;

    .peopleInfo {
        display: flex;
        align-items: center;
        width: ${(props) => (props.hasInvite ? 'auto' : '100%')};
        .avatarDiv {
            position: relative;
            width: max-content;
            height: fit-content;
        }
    }
    .options {
        opacity: 1;
    }
    :hover .options {
        opacity: 1;
    }
`;

export const PeopleItem = ({
    people,
    handleInvite,
    isHost,
    isWaiting,
    handleRemoveParticipant,
    handleMuteParticipant,
}) => {
    const [isInvited, setIsInvited] = useState(false);
    const handleAllowParticipant = async (id) => {
        try {
            const conferenceId = getConferenceIdFromURL();
            await conferenceApi.guestApprove(conferenceId, { participantId: id });
        } catch (e) {
            console.log(e);
        }
    };
    if (isWaiting) {
        return (
            <StyledPeopleItem hasInvite={!!handleInvite}>
                <div className="peopleInfo">
                    <div className="avatarDiv">{people && <AvatarUserPanel item={people} />}</div>

                    <span className="px-2 text-light">{people.name}</span>
                </div>
                <div>
                    <Button
                        className="mt-2"
                        variant="secondary"
                        onClick={() => handleAllowParticipant(people.id || people._id || people)}
                        style={{ padding: '0.2rem 0.5rem', borderRadius: '6px' }}
                    >
                        Admit
                    </Button>
                </div>
            </StyledPeopleItem>
        );
    }

    return (
        <StyledPeopleItem hasInvite={!!handleInvite}>
            <div className="peopleInfo">
                <div className="avatarDiv">{people && <AvatarUserPanel item={people} />}</div>

                <span className="px-2 text-light">
                    {people.name}
                    {people?.local && ' (You)'}
                    {people?.isMeetingHost && ' (Host)'}
                </span>
            </div>

            {handleInvite ? (
                <Button
                    className="BlueButton"
                    onClick={() => {
                        handleInvite(people);
                        setIsInvited(true);
                    }}
                >
                    {isInvited ? 'Invited' : 'Invite'}
                </Button>
            ) : (
                <div className="options mt-2">
                    {isHost && (
                        <Fragment>
                            {!people?.local && (
                                <Fragment>
                                    <Button
                                        className="BlueButton mr-1"
                                        onClick={() => handleMuteParticipant(people.id || people._id)}
                                    >
                                        Mute
                                    </Button>
                                    <Button
                                        className="RedButton"
                                        onClick={() => handleRemoveParticipant(people.id || people._id)}
                                    >
                                        Remove
                                    </Button>
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </div>
            )}
        </StyledPeopleItem>
    );
};
